import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12S0 5.373 0 12c0 6.628 5.373 12 12 12\"></path><path fill=\"#0052B4\" d=\"M11.999 0a11.98 11.98 0 0 0-9.6 4.8h19.2A11.98 11.98 0 0 0 12 0M11.999 24c3.926 0 7.411-1.886 9.6-4.8H2.4a11.98 11.98 0 0 0 9.6 4.8M0 12c0 .822.083 1.624.24 2.4h23.52a12.05 12.05 0 0 0 0-4.8H.24C.083 10.375 0 11.178 0 12\"></path><path fill=\"#D80027\" d=\"M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z\"></path><path fill=\"#F0F0F0\" d=\"m4.858 8.87.777 2.391h2.514l-2.034 1.478.777 2.391-2.034-1.478-2.034 1.478.777-2.391-2.035-1.478h2.515z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }